import { render, staticRenderFns } from "./PreferenceSection.vue?vue&type=template&id=5bdcabe3&"
import script from "./PreferenceSection.vue?vue&type=script&lang=js&"
export * from "./PreferenceSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports